












































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'

@Component
export default class ModalProcedimentoCompartilhadoIncluir extends Vue {
  $refs: {
    formProcedimentos: any
  }

  formRules = {
    valid: false,
    percentualAplicarRules: [(v: any) => !!v || 'O valor é obrigatório.'],
    tipoFieldRules: [(v: any) => !!v || 'O tipo é obrigatório.'],
    funcaoProcOrigemRules: [(v: any) => !!v || 'A função é obrigatória.'],
    funcaoProcDestinoRules: [(v: any) => !!v || 'A função é obrigatória.'],
  }

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalAddProcedimentoCompartilhado() { return this.getRegrasDeCalculoStore.modal.procedimentoCompartilhado }
  set showModalAddProcedimentoCompartilhado(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentoCompartilhado', value }) }

  get percentualAplicar() { return this.getRegrasDeCalculoStore.percentualAplicar }
  set percentualAplicar(value: any) { this.getRegrasDeCalculoStore.setPercentualAplicar(value) }

  get funcoes() { return this.getRegrasDeCalculoStore.funcoesProcedimento }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get tipos() { return this.getRegrasDeCalculoStore.tipos }
  get valoresReferencia() { return this.getRegrasDeCalculoStore.valoresReferencia }

  get funcaoProcOrigem() { return this.getRegrasDeCalculoStore.funcaoProcOrigem }
  set funcaoProcOrigem(value: any) { this.getRegrasDeCalculoStore.setFuncaoProcOrigem(value) }

  get funcaoProcDestino() { return this.getRegrasDeCalculoStore.funcaoProcDestino }
  set funcaoProcDestino(value: any) { this.getRegrasDeCalculoStore.setFuncaoProcDestino(value) }

  get fontePagadoraField() { return this.getRegrasDeCalculoStore.fontePagadoraField }
  set fontePagadoraField(value: any) { this.getRegrasDeCalculoStore.setFontePagadoraField(value) }

  get tipoField() { return this.getRegrasDeCalculoStore.tipoField }
  set tipoField(value: any) { this.getRegrasDeCalculoStore.setTipoField(value) }

  get valorReferencia() { return this.getRegrasDeCalculoStore.valorReferencia }
  set valorReferencia(value: any) { this.getRegrasDeCalculoStore.setValorReferencia(value) }

  get isEditMode() { return this.getRegrasDeCalculoStore.modalProcedimentoCompartilhadoMode }

  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addProcedimento() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.formProcedimentos.validate()) {
      this.loadingAddRegraCalculo = false
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Preencha os campos obrigatórios.',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }
    const request = await this.getRegrasDeCalculoStore.addProcedimentoCompartilhado()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.showModalAddProcedimentoCompartilhado = false
  }

  @Watch('showModalAddProcedimentoCompartilhado')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.funcaoProcOrigem = ''
      this.funcaoProcDestino = ''
      this.percentualAplicar = 0
      this.fontePagadoraField = null
      this.tipoField = null
      this.valorReferencia = null
      this.$refs.formProcedimentos.resetValidation()
    }
  }

  async mounted() {
    await this.getRegrasDeCalculoStore.getFuncoesProcedimento()
    await this.getRegrasDeCalculoStore.getFontesPagadoras()
  }
}
